import React, { useState } from "react";
import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";
import FilterButton from "../../../../components/ACS-Dashboard/ACS-Blocks/FilterButton";
import { FiSearch, FiChevronDown } from "react-icons/fi";

const InventoryActions = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  fetchInventory,
  totalItems
}) => {

  const handleSearch = () => {
        fetchInventory(searchQuery, statusFilter);
  };

  const handleStatusFilter = (event) => {
    const selectedStatus =
      event.target.value === "all" ? null : event.target.value === "active";
    setStatusFilter(selectedStatus);
    fetchInventory(searchQuery, selectedStatus);
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    setStatusFilter(null);
    fetchInventory();
  };

  return (
    <div className="flex flex-wrap justify-between items-center mb-4 p-2 rounded-md">
      {/* 🔹 Left Side: Filters & Search */}
      <div className="flex flex-wrap items-center gap-2">
        {/* 🔽 Status Dropdown Filter */}
        <div className="relative">
          <select
            value={
              statusFilter === null
                ? "all"
                : statusFilter
                ? "active"
                : "not_active"
            }
            onChange={handleStatusFilter}
            className="appearance-none px-4 py-2 border rounded-full shadow-sm bg-white text-black focus:ring-2 focus:ring-blue-500"
          >
            <option value="all">Status</option>
            <option value="active">Active</option>
            <option value="not_active">Not Active</option>
          </select>
          <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <FiChevronDown className="text-black" />
          </span>
        </div>

        {/* 🧹 Clear Filters Button */}
        <FilterButton
          text="Clear Filters"
          backgroundColor="gray"
          textColor="white"
          onClick={handleClearFilters}
        />

        {/* 🔍 Search Box */}
        <div className="relative flex items-center border rounded-full px-3 py-1.5 w-60">
          <input
            type="text"
            placeholder="Search inventory..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full outline-none text-sm"
          />
          <button
            onClick={handleSearch}
            className="absolute right-3 text-gray-500 hover:text-gray-700"
          >
            <FiSearch size={18} />
          </button>
        </div>
        {/* ✅ Total Orders Display (Next to Search Box) */}
        <span className="ml-3 text-gray-500 text-sm">
          Total: {totalItems} orders
        </span>
      </div>

      {/* 🔹 Right Side: Actions */}
      {/* <div className="flex items-center gap-2">
        <Button
          text="New Inventory Item"
          backgroundColor="#223688"
          textColor="white"
          fontSize="14px"
          padding="10px 18px"
          borderRadius="24px"
        />
      </div> */}
    </div>
  );
};

export default InventoryActions;
